import React from "react";
import { Stack } from "@mui/material";
import {
  TextInputField,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useCreateEmailTemplateStore } from "../../stores/Hooks";
import { getEmailTemplateValidationErrorMessage } from "../../utils/getEmailTemplateValidationErrorMessage";
import { CampaignEmailPlaceholderPicker } from "../inputs/CampaignEmailPlaceholderPicker";
import { EmailTemplateContentRTE } from "../inputs/EmailTemplateContentRTE";

const TEMPLATE_FIELD_WIDTH = "600px";

export const CreateEmailTemplateForm: React.FC = observer(() => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const createEmailTemplateStore = useCreateEmailTemplateStore();

  const validationErrors = getEmailTemplateValidationErrorMessage(t, {
    name: createEmailTemplateStore.emailTemplateName.validationError,
    content: createEmailTemplateStore.emailTemplateContent.validationError,
  });

  return (
    <Stack gap={spacing.spaceLG}>
      <Stack width="100%" maxWidth={TEMPLATE_FIELD_WIDTH}>
        <TextInputField
          name="template"
          label={t("emailTemplates.titleLabel")}
          value={createEmailTemplateStore.emailTemplateName.name}
          type="text"
          onTextChange={(value) =>
            createEmailTemplateStore.emailTemplateName.setName(value)
          }
          placeholder={t("emailTemplates.titlePlaceholder")}
          error={!!validationErrors.name}
          helperText={validationErrors.name}
          required
        />
      </Stack>
      <Stack width="100%" maxWidth={TEMPLATE_FIELD_WIDTH}>
        <CampaignEmailPlaceholderPicker projectId={null} />
      </Stack>
      <EmailTemplateContentRTE
        mode="editable"
        initialValue={createEmailTemplateStore.emailTemplateContent.content}
        onChange={(value) =>
          createEmailTemplateStore.emailTemplateContent.setContent(value)
        }
        error={!!validationErrors.content}
        helperText={validationErrors.content}
        rteFileService={
          createEmailTemplateStore.emailTemplateContent.rteFileService
        }
        enableRTEPopupZIndexFix
      />
    </Stack>
  );
});
